import React from 'react'
import Region from './components/Region'

function App() {
  return (
    <div>
        <Region />
    </div>
  )
}

export default App